import {
  Box,
  Card,
  CardContent,
  Divider as MuiDivider,
  Grid,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Tooltip,
  Button,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { spacing } from "@mui/system";
import { FormAccordoProvider, useFormAccordo } from "./ContextAccordo";
import styled from "@emotion/styled";
import Garanzie from "./Garanzie";
import Agenzie from "./Agenzie";
import Condizioni from "./Condizioni";
import { Save } from "@mui/icons-material";
import Impostazioni from "./Impostazioni";
import { useNavigate, useParams } from "react-router-dom";
import Documenti from "./Documenti";
import { API_BASE_URL } from "../../../config";

const Divider = styled(MuiDivider)(spacing);

const ITEM_HEIGHT = 62;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

function AccordiDetailsComponent() {
  const { formState, dispatch } = useFormAccordo();
  const [valueTabs, setValueTabs] = useState(0);
  const [loadingPage, setLoadingPage] = useState(true);
  const { idUID } = useParams();
  const navigate = useNavigate();

  const handleSave = async () => {
    console.log(formState);
    const token = sessionStorage.getItem("token");
    /*  try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
          data: formState,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/apiUpDo/provaAccordi`,
        requestOptions
      );
      const responseData = await response.json();
      console.log(responseData);
    } catch (error) {
      console.log(error);
      return error;
    } */
  };

  async function accordiGetDetails(idUID) {
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          data: {
            idUID: idUID === undefined ? "" : idUID,
          },
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/accordiGetDetails`,
        requestOptions
      );

      const responseData = await response.json();
      if (responseData.status === -1) {
        navigate("/auth/sign-in");
      }
      if (responseData.status === 0) {
        navigate("/private");
      }
      if (responseData.data !== null) {
        dispatch({ type: "SET_DATA_API", payload: responseData.data });
      }
      setLoadingPage(false);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  useEffect(() => {
    accordiGetDetails(idUID);
  }, [idUID]);

  return (
    <React.Fragment>
      {loadingPage ? (
        <Box
          sx={{
            width: "calc(100vw - 40px)",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <React.Fragment>
          <Helmet title="Accordi" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h3" display="inline">
              {formState.accordo.nome}
            </Typography>
            <Tooltip title="Salva">
              <Button variant="contained" onClick={handleSave}>
                <Save />
              </Button>
            </Tooltip>
          </Box>
          <Divider my={4} />
          <Card sx={{ marginBottom: "16px", paddingTop: "8px" }}>
            <CardContent>
              <Grid
                container
                spacing={3}
                wrap="wrap"
                sx={{ maxWidth: { xs: "calc(100vw - 60px)" } }}
              >
                <Grid item sm={3} xs={12}>
                  <TextField
                    size="small"
                    margin="none"
                    label="Nome"
                    required
                    fullWidth
                    value={formState.accordo.nome}
                    id="nome"
                    onChange={(e) =>
                      dispatch({
                        type: "set_accordo",
                        payload: {
                          nome: e.target.value,
                        },
                      })
                    }
                    /* error={state.errorNumeroPolizza} */
                  />
                </Grid>
                <Grid item sm={3} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="compagnia-label">Compagnia</InputLabel>
                    <Select
                      labelId="compagnia-label"
                      id="compagnia"
                      name="compagnia"
                      label="Compagnia"
                      /* defaultValue={compagniaArray.value}*/
                      value={formState.accordo.compagnia.value}
                      MenuProps={MenuProps}
                      onChange={(e) => {
                        dispatch({
                          type: "set_accordo",
                          payload: {
                            compagnia: {
                              ...formState.accordo.compagnia,
                              value: e.target.value,
                            },
                          },
                        });
                      }}
                    >
                      {formState.accordo.compagnia.dataset.map((el) => (
                        <MenuItem key={el.label} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="stato-label">Stato</InputLabel>
                    <Select
                      labelId="stato-label"
                      id="stato"
                      name="stato"
                      label="Stato"
                      value={formState.accordo.stato.value}
                      MenuProps={MenuProps}
                      onChange={(e) => {
                        dispatch({
                          type: "set_accordo",
                          payload: {
                            stato: {
                              ...formState.accordo.stato,
                              value: e.target.value,
                            },
                          },
                        });
                      }}
                    >
                      {formState.accordo.stato.dataset.map((el) => (
                        <MenuItem key={el.label} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="tipologia-label">Tipologia</InputLabel>
                    <Select
                      labelId="tipologia-label"
                      id="tipologia"
                      name="tipologia"
                      label="Tipologia"
                      value={formState.accordo.tipologia.value}
                      MenuProps={MenuProps}
                      onChange={(e) => {
                        dispatch({
                          type: "set_accordo",
                          payload: {
                            tipologia: {
                              ...formState.accordo.tipologia,
                              value: e.target.value,
                            },
                          },
                        });
                      }}
                    >
                      {formState.accordo.tipologia.dataset.map((el) => (
                        <MenuItem key={el.label} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="provenienza-label">Provenienza</InputLabel>
                    <Select
                      labelId="provenienza-label"
                      id="provenienza"
                      name="provenienza"
                      label="Provenienza"
                      value={formState.accordo.provenienza.value}
                      MenuProps={MenuProps}
                      onChange={(e) => {
                        dispatch({
                          type: "set_accordo",
                          payload: {
                            provenienza: {
                              ...formState.accordo.provenienza,
                              value: e.target.value,
                            },
                          },
                        });
                      }}
                    >
                      {formState.accordo.provenienza.dataset.map((el) => (
                        <MenuItem key={el.label} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="acquistabile-label">
                      Acquistabile
                    </InputLabel>
                    <Select
                      labelId="acquistabile-label"
                      id="acquistabile"
                      name="acquistabile"
                      label="Acquistabile"
                      value={formState.accordo.acquistabile.value}
                      MenuProps={MenuProps}
                      onChange={(e) => {
                        dispatch({
                          type: "set_accordo",
                          payload: {
                            acquistabile: {
                              ...formState.accordo.acquistabile,
                              value: e.target.value,
                            },
                          },
                        });
                      }}
                    >
                      {formState.accordo.acquistabile.dataset.map((el) => (
                        <MenuItem key={el.label} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="visibile-label">Visibile</InputLabel>
                    <Select
                      labelId="visibile-label"
                      id="visibile"
                      name="visibile"
                      label="Visibile"
                      value={formState.accordo.visibile.value}
                      MenuProps={MenuProps}
                      onChange={(e) => {
                        dispatch({
                          type: "set_accordo",
                          payload: {
                            visibile: {
                              ...formState.accordo.visibile,
                              value: e.target.value,
                            },
                          },
                        });
                      }}
                    >
                      {formState.accordo.visibile.dataset.map((el) => (
                        <MenuItem key={el.label} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="fornitore-label">Fornitore</InputLabel>
                    <Select
                      labelId="fornitore-label"
                      id="fornitore"
                      name="fornitore"
                      label="Fornitore"
                      value={formState.accordo.fornitore.value}
                      MenuProps={MenuProps}
                      onChange={(e) => {
                        dispatch({
                          type: "set_accordo",
                          payload: {
                            fornitore: {
                              ...formState.accordo.fornitore,
                              value: e.target.value,
                            },
                          },
                        });
                      }}
                    >
                      {formState.accordo.fornitore.dataset.map((el) => (
                        <MenuItem key={el.label} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={12} xs={12}>
                  <TextField
                    size="small"
                    margin="none"
                    label="Note"
                    required
                    fullWidth
                    value={formState.accordo.note}
                    id="note"
                    onChange={(e) =>
                      dispatch({
                        type: "set_accordo",
                        payload: {
                          note: e.target.value,
                        },
                      })
                    }
                    /* error={state.errorNumeroPolizza} */
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Divider my={4} />
          <Tabs
            value={valueTabs}
            onChange={(e, newValue) => setValueTabs(newValue)}
            sx={{ marginTop: "16px" }}
          >
            <Tab label="Condizioni" />
            <Tab label="Agenzie" />
            <Tab label="Garanzie Accessori" />
            <Tab label="Impostazioni" />
            <Tab label="Documenti" />
            <Tab label="Regole" />
          </Tabs>
          <Card sx={{ marginTop: "16px" }}>
            <CardContent>
              <CustomTabPanel value={valueTabs} index={0}>
                <Condizioni />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={1}>
                <Agenzie />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={2}>
                <Garanzie />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={3}>
                <Impostazioni />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={4}>
                <Documenti />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={5}>
                {/* Regole */}
              </CustomTabPanel>
            </CardContent>
          </Card>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

const AccordiDetails = () => (
  <FormAccordoProvider>
    <AccordiDetailsComponent />
  </FormAccordoProvider>
);

export default AccordiDetails;
